<template>
    <v-row :class="!$vuetify.breakpoint.smAndDown ? 'ma-2' : ''">
        <v-col cols="12" md="6" v-if="selectedContract">
            <AgentLandline
                v-if="selectedContract.landline"
                :landlineSubscriptions="selectedContract.landline.landlineSubscriptions"
                :selectedContractId="selectedContractId"
            />
            <AgentAgile
                v-if="selectedContract.agile"
                :agileSubscriptions="selectedContract.agile.agileSubscriptions"
                :selectedContractId="selectedContractId"
            />
            <!-- <AgentNetfilx
                :netflixSubscriptions="selectedContract.netflixSubscriptions.netflixSubscriptions"
                :selectedContractId="selectedContractId"
            /> -->
        </v-col>
        <v-col cols="12" md="6" v-if="selectedContract">
            <AgentMobile 
                v-if="selectedContract.mobile"
                :mobileSubscriptions="selectedContract.mobile.mobileSubscriptions"
                :selectedContractId="selectedContractId"
            />
        </v-col>
    </v-row>
</template>

<script>
import AgentLandline from './AgentLandline.vue';
import AgentMobile from './AgentMobile.vue';
import AgentAgile from './AgentAgile.vue';
import AgentNetfilx from './AgentNetfilx.vue';

export default {
    data: () => ({
    }),
    components: {
        AgentLandline,
        AgentMobile,
        AgentAgile,
        AgentNetfilx,
    },
    props: {
        selectedContract: {
            type: Object,
            default: () => ({
                landline: {
                    landlineSubscriptions: [],
                },
                mobile: {
                    mobileSubscriptions: [],
                },
                agile: {
                    agileSubscriptions: [],
                },
                netflixSubscriptions: {
                    netflixSubscriptions: [],
                },
            }),
        },
        selectedContractId: {
            type: String,
        },
    },
};
</script>